const eventAdvertiseString = {
  VIEW: "view",
  // CLICK: "click",
};
const eventAdvertisePersian = {
  VIEW: "تعداد نمایش",
  // CLICK: "کلیک",
};
export default { eventAdvertiseString, eventAdvertisePersian };
